/**
 * Created by Andrey Popov on 07.09.26
 */

// one entry per achievement the shelves can show; the name marks gathered ones
cleverapps.Tool.achievements = ToolFolder.create(() => {
    const listNames = () => {
        const names = {};
        cleverapps.achievements.listWindowAchievements().forEach((config) => {
            const name = `${config.id}_${config.expedition || config.title}${cleverapps.achievements.isGathered(config.id) ? " (gathered)" : ""}`;
            names[name] = config;
        });
        return names;
    };

    const perAchievement = (action) => ToolFolder.create(() => {
        const res = {};
        const names = listNames();
        Object.keys(names).forEach((name) => {
            res[name] = () => action(names[name]);
        });
        return res;
    });

    return {
        showWindow: displayToolWindow(() => {
            new AchievementsWindow();
        }),

        rewardWindow: perAchievement((config) => {
            cleverapps.focusManager.closeAllWindows();
            cleverapps.focusManager.display({
                focus: "AchievementRewardWindowTool",
                action: function (f) {
                    new AchievementRewardWindow(config);
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        }),

        grant: perAchievement((config) => {
            cleverapps.achievements.grant(config.id);
        }),

        revoke: perAchievement((config) => {
            cleverapps.achievements.revoke(config.id);
        })
    };
});
